(() => {
  const i18n = window.MayLondonI18n;
  const { t } = i18n;
  if (window.MayLondonFilters) return;
  window.MayLondonFilters = true;
  const instances = new Map();

  function init(scope = document) {
    scope.querySelectorAll('[data-collection-browser]').forEach((root) => {
      if (instances.has(root)) return;
      const form = root.querySelector('[data-collection-filter-form]');
      const dialog = root.querySelector('[data-collection-filter-dialog]');
      const trigger = root.querySelector('[data-filter-open]');
      const slot = root.querySelector('[data-filter-slot]');
      if (!form || !dialog || !trigger || typeof dialog.showModal !== 'function') return;
      const controller = new AbortController();
      const { signal } = controller;
      const mobile = matchMedia('(max-width: 749px)');
      const groups = [...form.querySelectorAll('[data-filter-group]')];
      let wasLocked = false;
      let drawerActive = false;
      root.classList.add('is-enhanced');

      function groupCount(group) {
        if (group.dataset.filterType === 'price_range') return [...group.querySelectorAll('input[type="number"]')].some(input => input.value !== '') ? 1 : 0;
        return group.querySelectorAll('input[type="checkbox"]:checked').length;
      }
      function updateGroup(group) {
        const count = groupCount(group);
        const badge = group.querySelector('[data-filter-group-count]');
        badge.textContent = i18n.number(count);
        badge.hidden = count === 0;
      }
      function checkPrices() {
        for (const range of form.querySelectorAll('[data-filter-price]')) {
          const min = range.querySelector('[data-filter-min]');
          const max = range.querySelector('[data-filter-max]');
          max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? t('price_range_error') : '');
        }
      }
      function resetGroup(group) {
        group.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
        group.querySelectorAll('input[type="number"]').forEach(input => { input.value = ''; input.setCustomValidity(''); });
        updateGroup(group);
      }
      function restore() {
        if (!drawerActive) return;
        drawerActive = false;
        slot.append(form);
        groups.forEach((group, index) => { group.open = !mobile.matches && (index < 3 || groupCount(group) > 0); });
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('is-filter-locked');
        const anotherPanel = document.querySelector('dialog[open], [data-cart-drawer].is-open, [data-wishlist-drawer].is-open, [data-size-guide-modal].is-open');
        if (!wasLocked && !anotherPanel) document.body.classList.remove('is-locked');
        if (mobile.matches && trigger.isConnected) trigger.focus();
      }
      function close() {
        if (dialog.open) dialog.close();
        restore();
      }
      trigger.addEventListener('click', () => {
        if (!mobile.matches) {
          root.classList.toggle('is-filters-hidden');
          trigger.setAttribute('aria-expanded', String(!root.classList.contains('is-filters-hidden')));
          return;
        }
        if (dialog.open) return;
        wasLocked = document.body.classList.contains('is-locked');
        drawerActive = true;
        dialog.querySelector('[data-filter-dialog-content]').append(form);
        groups.forEach((group, index) => { group.open = groupCount(group) > 0 || index === 0; });
        dialog.showModal();
        document.body.classList.add('is-locked', 'is-filter-locked');
        trigger.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-filter-close]').focus();
      }, { signal });
      dialog.querySelector('[data-filter-close]').addEventListener('click', close, { signal });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); }, { signal });
      dialog.addEventListener('close', restore, { signal });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }, { signal });
      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || mobile.matches) return;
        const group = event.target.closest('[data-filter-group][open]');
        if (group) { group.open = false; group.querySelector('summary').focus(); event.preventDefault(); }
      }, { signal });
      groups.forEach(group => {
        group.querySelector('[data-filter-reset]').addEventListener('click', (event) => { event.preventDefault(); resetGroup(group); }, { signal });
        group.addEventListener('input', () => { checkPrices(); updateGroup(group); }, { signal });
        group.addEventListener('change', event => { checkPrices(); updateGroup(group); if (!mobile.matches && event.target.type === 'checkbox') form.requestSubmit(); }, { signal });
      });
      form.querySelector('[data-filter-clear]')?.addEventListener('click', (event) => { event.preventDefault(); groups.forEach(resetGroup); }, { signal });
      form.querySelector('[data-filter-sort]').addEventListener('change', () => {
        if (!mobile.matches) { checkPrices(); form.requestSubmit(); }
      }, { signal });
      form.addEventListener('invalid', (event) => {
        const group = event.target.closest('[data-filter-group]');
        if (group) group.open = true;
      }, { capture: true, signal });
      form.addEventListener('submit', (event) => {
        checkPrices();
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
      }, { signal });
      const resize = () => {
        if (!mobile.matches) close();
        trigger.setAttribute('aria-controls', mobile.matches ? dialog.id : form.querySelector('.collection-browser__groups').id);
        if (mobile.matches) trigger.setAttribute('aria-haspopup', 'dialog'); else trigger.removeAttribute('aria-haspopup');
        trigger.setAttribute('aria-expanded', String(!mobile.matches && !root.classList.contains('is-filters-hidden')));
      };
      mobile.addEventListener('change', resize);
      resize();
      checkPrices();
      instances.set(root, () => { close(); mobile.removeEventListener('change', resize); controller.abort(); root.classList.remove('is-enhanced'); });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => { if (event.target.contains(root)) { destroy(); instances.delete(root); } });
  });
  init();
})();
